import { updateProfile } from "@/api";
import { useAuth } from "@/contexts/auth/useAuth";
import { parseAuthError } from "@/utils/auth-errors";
import { Box } from "@mui/material";
import {
    FormContainer,
    FormEmailElement,
    FormTextFieldElement,
} from "@rhf-kit/mui";
import { useMutation } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { Button } from "../../buttons/Button";

interface FormData {
    email: string;
}

export const ChangeEmailForm = () => {
    const { user, session } = useAuth();

    const profileMutation = useMutation({
        mutationFn: updateProfile,
        onSuccess: () => {
            enqueueSnackbar({
                variant: "success",
                message: "Email updated",
            });

            session.refresh();
        },
        onError: (error: unknown) => {
            const { message } = parseAuthError(error);
            enqueueSnackbar({
                variant: "error",
                message: message,
            });
        },
    });

    const handleSubmit = async (formData: FormData) => {
        profileMutation.mutate({
            email: formData.email,
        });
    };

    if (!user) {
        return null;
    }

    return (
        <FormContainer
            values={{ currentEmail: user.email, email: "" }}
            onSuccess={handleSubmit}
        >
            <FormTextFieldElement
                id="currentEmail"
                fullWidth
                name="currentEmail"
                label="Current Email"
                margin="normal"
                value={user.email}
                disabled
            />

            <FormEmailElement
                id="email"
                fullWidth
                name="email"
                label="New Email"
                margin="normal"
                renderIcon={false}
                required
            />
            <Box mt={2} display="flex">
                <Box flexGrow={1} />
                <Button
                    loading={profileMutation.isPending}
                    variant="contained"
                    color="dark"
                    type="submit"
                    sx={{ borderRadius: 2 }}
                >
                    Save Changes
                </Button>
            </Box>
        </FormContainer>
    );
};
